<template>
  <v-sheet
    class="d-inline-flex align-center justify-center"
    :style="{ border: '2.5px solid', borderColor: color }"
    :height="size"
    :width="size"
    rounded="rounded"
  >
    <slot></slot>
  </v-sheet>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const mn = '[components/OutlinedAvatar.vue]'

export default defineComponent({
  props: {
    rounded: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: '32',
    },
    color: {
      type: String,
      default: '',
    },
  },
})
</script>
